import moment from "moment";

import { ApplicationEnum } from "../../enums/ApplicationEnum";

export class ReadmitHc {
    public AgencyId: string = "";
    public PatientId: string = "";
    public AgencyLocationId: string = "";
    public ReferralDate: string = "";
    public ReAdmissionDate: string = moment().format("MM/DD/YYYY");
    public ReAdmissionHour: string = "";
    public PhysicianId: string = null;
    public ClinicianId: string = null;
    public CaseManagerId: string = null;
    public Application: ApplicationEnum = ApplicationEnum.HomeCare;

    public constructor(data?: ReadmitHc) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
